function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5611 6.92337C10.5611 8.33982 9.41651 9.48443 8.00006 9.48443C6.5836 9.48443 5.439 8.33982 5.439 6.92337C5.439 5.50691 6.5836 4.3623 8.00006 4.3623C9.41651 4.3623 10.5611 5.50691 10.5611 6.92337Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.8396C10.5253 12.8396 12.8789 11.3516 14.5171 8.77619C15.161 7.7675 15.161 6.07205 14.5171 5.06336C12.8789 2.48799 10.5253 1 8 1C5.47471 1 3.1211 2.48799 1.48288 5.06336C0.839039 6.07205 0.839039 7.7675 1.48288 8.77619C3.1211 11.3516 5.47471 12.8396 8 12.8396Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.fdd33abf6cf36121a406544392e84d15.svg";
export { ForwardRef as ReactComponent };